import { useCallback } from 'react'
import { usePageDestinationAccess } from './usePageAccess'
import { localPageDestination } from './PageAnchor'

export const useOpenPageInNewTab = (): ((href?: string) => void) => {
  const canOpen = usePageDestinationAccess()
  return useCallback(
    (href = '') => {
      if (!href) return
      const destination = localPageDestination(href)
      if (destination && !canOpen(destination)) return
      Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href,
      }).click()
    },
    [canOpen],
  )
}
